<template>
  <div class="m-banner block">
    <img v-if="!isSwiper" :src="bg" alt="">
    <div v-if="isSwiper">
      <swiper :options="swiperOptions">
        <swiper-slide
            class="swiper-slide"
            v-for="(item, i) in bg"
            :key="item.id"
        >
          <img :src="item.imgUrl" alt="" @click="clickHomeSlider(item)">
        </swiper-slide>
      </swiper>
    </div>
    <div class="lg-btn" v-if="!hiddenBtn">
      <div
        :class="{ active: active === 'zh', zh: true }"
        @click="changeLang('zh')"
      >中</div>
      <div
        :class="{ active: active === 'en', en: true }"
        @click="changeLang('en')"
      >En</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ['bg', 'hiddenBtn'],
  data() {
    return {
      active: 'zh',
      swiperOptions: {
        autoplay: true,
        duration: 5000,
        loop: true,
        pagination: {
          el: '.n-p-pagination',
          clickable: true
        }
      },

    }
  },
  methods: {
    changeLang(e) {
      if(e == this.active) {
        return;
      }

      this.$store.commit('setMLang', e);
      this.active = e;
      sessionStorage.setItem('mlang', e);
      document.title = this.$route.meta[e === 'zh' ? 'title' : 'enTit'];

      const {path} = this.$route;

      if(e === 'zh') {
        this.$router.push(path.substr(3));
      } else {
        this.$router.push('/us' + path);
      }
    },
    clickHomeSlider(item) {
      // 后端无接口，前端写固定地址
      const path = this.$route.path;
      if(path == '/mobile/home' || path == '/us/mobile/home') {

      //     //后端暂时没有该功能，前端写死。
      if(item.id === '63c10948c4f1571ef252afa1'){
        
        let itemId = this.$store.state.mlang === 'en' ? '63d8736d774f54243b88f384' : '63c103aac4f1571ef252afa0'

        window.open('/mobile/detail/' + itemId + '?lang=' + this.$store.state.mlang);

      }
      }
    }
  },
  computed: {
    isSwiper() {
      return typeof this.bg == 'object'
    }
  },
  created() {
    this.active = this.$store.state.mlang;
  }
}
</script>

<style lang="less">
@import "../../common/theme";
@ba-size-1: calc(@mobileFont * .3);
@ba-size-2: calc(@mobileFont * .4);
.mobile-home {
  .m-banner {
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .lg-btn {
      position: absolute;
      right: @ba-size-1;
      bottom: @ba-size-1;
      border: 1px solid #037698;
      display: flex;
      align-items: center;
      background: #fff;
      z-index: 1;
      >div {
        color: #037698;
        padding: 0 6px;
        line-height: @ba-size-2;
      }
      .active {
        background: #037698;
        color: #fff;
      }
    }
  }
}
</style>
